require('./mortgageRequestManageAppraiserVisit.scss');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { formatText } = require('core/i18n').i18n;

// @ components
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const OKSelect = require('components/commons/OKSelect/OKSelect');

// @ constants
const {
    NOT_SELECT_DATE,
    SELECT_DATE,
    NOT_ATTEND,
    ATTEND
} = require('constants/mortgageRequestAppraisalRequest').APPRAISER_VISIT_OPTIONS;
const {
    INDIFFERENT,
    MORNING,
    LATE
} = require('constants/mortgageRequestAppraisalRequest').SCHEDULE_OPTIONS;
const { SECOND_STEP } = require('constants/index');
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');
// @ actions
const actions = require('actions/mortgageRequest/mortgageRequestAppraisalRequest');
// @utilities
const classNames = require('classnames');

class MortgageRequestManageAppraiserVisit extends React.Component {

    constructor(props) {
        super(props);

        this.handleAttendOptionChange = this.handleAttendOptionChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.onHandleDatePickerChange = this.onHandleDatePickerChange.bind(this);
        this.handleScheduleChange = this.handleScheduleChange.bind(this);
    }

    onHandleDatePickerChange(date) {
        this.props.updateAppraisalDate(date);
    }

    buildSchedule() {
        const { mortgageRequestAppraisalRequest, isClientWithoutAccounts } = this.props;

        const appraiserVisitState = mortgageRequestAppraisalRequest.getIn(['steps', SECOND_STEP, 'appraiserVisitData']);
        const minDate = appraiserVisitState.get('minDate');
        const selectedVisitDate = appraiserVisitState.get('selectedVisitDate');
        const scheduleSelectedOption = appraiserVisitState.get('scheduleSelectedOption');
        const scheduleIsDirty = appraiserVisitState.get('scheduleIsDirty');
        const scheduleError = scheduleIsDirty && appraiserVisitState.get('hasScheduleError');
        const scheduleOptions = this.scheduleOptions();

        const mainClasses = classNames({
            'col-xs-4': isClientWithoutAccounts,
            'col-xs-3': !isClientWithoutAccounts
        });

        return (
            <div className="row">
                <div className={mainClasses}>
                    <DatePickerCustom
                        callback={this.onHandleDatePickerChange}
                        selectedDate={selectedVisitDate}
                        label={formatText("mortgageRequestAppraisalRequest-appraiserVisitSelectDateLabel")}
                        minDate={minDate}
                        placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                        locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                        dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                    />
                </div>
                <div className="col-xs-4">
                    <OKSelect
                        options={scheduleOptions}
                        onChange={this.handleScheduleChange}
                        value={scheduleSelectedOption}
                        label={formatText("mortgageRequestAppraisalRequest-appraiserVisitSelectSchedule")}
                        errorState={scheduleError}
                    />
                </div>
            </div>
        );
    }

    buildSelectDateSection() {
        const { mortgageRequestAppraisalRequest } = this.props;

        const appraiserVisitState = mortgageRequestAppraisalRequest.getIn(['steps', SECOND_STEP, 'appraiserVisitData']);
        const visitDateValue = appraiserVisitState.get('selectVisitDate');
        const visitDateIsDirty = appraiserVisitState.get('visitDateIsDirty');
        const visitDateError = visitDateIsDirty && appraiserVisitState.get('hasSelectVisitDateError');
        const schedule = this.buildSchedule();

        return (
            <div>
                <h3 className="mortgage-request-manage-appraiser-visit__question">{formatText('mortgageRequestAppraisalRequest-appraiserVisitwantToSelectDate')}</h3>
                <p className="mortgage-request-manage-appraiser-visit__text">{formatText('mortgageRequestAppraisalRequest-appraiserVisitwantToSelectDateText')}</p>
                <RadioButtonGroup
                    name="selectVisitDate"
                    idPrefix="cancelChequebookMotiveRadio"
                    selectedValue={visitDateValue}
                    onChange={this.handleDateChange}
                    className="mortgage-request-manage-appraiser-visit__radio-group"
                    errorState={visitDateError}
                    errorMessage={formatText('mortgageRequestAppraisalRequest-appraiserSelectAccountError0')}
                >
                    <RadioButton label={formatText('mortgageRequestAppraisalRequest-appraiserVisitNotSelectDate')} value={NOT_SELECT_DATE} />
                    <RadioButton label={formatText('mortgageRequestAppraisalRequest-appraiserVisitSelectDate')} value={SELECT_DATE} />
                </RadioButtonGroup>

                {visitDateValue === SELECT_DATE && schedule}
            </div>
        );
    }

    handleAttendOptionChange(value) {
        this.props.updateAttendOption(value);
    }

    handleDateChange(value) {
        this.props.updateAppraiserVisitDate(value);
    }

    handleScheduleChange(option) {
        this.props.updateScheduleOption(option.value);
    }

    scheduleOptions() {
        const options = [
            INDIFFERENT,
            MORNING,
            LATE
        ];

        return options.map((value, index) => {
            const label = formatText(`mortgageRequestAppraisalRequest-appraiserVisitScheduleOption${index}`);

            return {
                label,
                value
            }
        });
    }

    render() {
        const { mortgageRequestAppraisalRequest } = this.props;

        const appraiserVisitState = mortgageRequestAppraisalRequest.getIn(['steps', SECOND_STEP, 'appraiserVisitData']);
        const attendVisitValue = appraiserVisitState.get('selectAttendVisit');
        const attentVisitError = appraiserVisitState.get('hasSelectAttendVisitError') && appraiserVisitState.get('selectAttendVisitIsDirty');
        const selectDate = this.buildSelectDateSection();

        return (
            <div className="mortgage-request-manage-appraiser-visit">
                <h3 className="mortgage-request-manage-appraiser-visit__title">{formatText('mortgageRequestAppraisalRequest-appraiserVisitTitle')}</h3>
                <p className="mortgage-request-manage-appraiser-visit__text">{formatText('mortgageRequestAppraisalRequest-appraiserVisitText')}</p>
                <h3 className="mortgage-request-manage-appraiser-visit__question">{formatText('mortgageRequestAppraisalRequest-appraiserVisitWantToAttend')}</h3>
                <RadioButtonGroup
                    name="attendVisit"
                    idPrefix="attendVisitRadio"
                    selectedValue={attendVisitValue}
                    onChange={this.handleAttendOptionChange}
                    errorState={attentVisitError}
                    errorMessage={formatText('mortgageRequestAppraisalRequest-appraiserSelectAccountError0')}
                >
                    <RadioButton label={formatText('mortgageRequestAppraisalRequest-appraiserVisitDontWantToAttend')} value={NOT_ATTEND} />
                    <RadioButton label={formatText('mortgageRequestAppraisalRequest-appraiserVisitYesWantToAttend')} value={ATTEND} />
                </RadioButtonGroup>

                {attendVisitValue === ATTEND && selectDate}
            </div>
        );
    }
}

MortgageRequestManageAppraiserVisit.propTypes = {
    mortgageRequestAppraisalRequest: PropTypes.object.isRequired,
    updateAttendOption: PropTypes.func.isRequired,
    updateAppraiserVisitDate: PropTypes.func.isRequired,
    updateAppraisalDate: PropTypes.func.isRequired,
    updateScheduleOption: PropTypes.func.isRequired,
    isClientWithoutAccounts: PropTypes.bool
};

module.exports = connect(state => ({
    mortgageRequestAppraisalRequest: state.mortgageRequestAppraisalRequest
}), {
        updateAttendOption: actions.updateAttendOption,
        updateAppraiserVisitDate: actions.updateAppraiserVisitDate,
        updateAppraisalDate: actions.updateAppraisalDate,
        updateScheduleOption: actions.updateScheduleOption
    })(MortgageRequestManageAppraiserVisit);
